import config from '../config/ConfigProvider';

const useHasLibrary = () => config.value('countryCode') === 'se';

export default useHasLibrary;
